import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Button, Spinner } from 'reactstrap';
import './personalDetails.css';
import { ReactComponent as PersonalDetailsCompleteIcon } from 'assets/images/steppersvg/aboutComplete.svg';
import { ReactComponent as PersonalDetailsIcon } from 'assets/images/steppersvg/about.svg';
import { ReactComponent as DirectorListIconComplete } from 'assets/images/steppersvg/listDirectorcomplete.svg';
import { ReactComponent as DirectorListIcon } from 'assets/images/steppersvg/listDirectors.svg';
import { ReactComponent as KeyStrengthIconComplete } from 'assets/images/steppersvg/keyStrengthComplete.svg';
import { ReactComponent as KeyStrengthIcon } from 'assets/images/steppersvg/keyStrength.svg';
import { ReactComponent as FinSummaryIconComplete } from 'assets/images/steppersvg/finsummaryComplete.svg';
import { ReactComponent as FinSummaryIcon } from 'assets/images/steppersvg/finsummary.svg';
import { ReactComponent as DebtIconComplete } from 'assets/images/steppersvg/debtComplete.svg';
import { ReactComponent as DebtIcon } from 'assets/images/steppersvg/debt.svg';
import { ReactComponent as CustomerSupplierIconComplete } from 'assets/images/steppersvg/customerSupplierComplete.svg';
import { ReactComponent as CustomerSupplierIcon } from 'assets/images/steppersvg/customerSupplier.svg';
import { ReactComponent as TermsheetIconComplete } from 'assets/images/steppersvg/termsheetComplete.svg';
import { ReactComponent as TermsheetIcon } from 'assets/images/steppersvg/termsheet.svg';
import { ReactComponent as CamIconComplete } from 'assets/images/steppersvg/camComplete.svg';
import { ReactComponent as CamIcon } from 'assets/images/steppersvg/cam.svg';
import queryString from 'query-string';

import { useNavigate } from 'react-router-dom';
import { decryptedValue } from 'common/utility';
import Breadcrumbs from "components/Common/BreadcrumbTitle";
import EntityTermsheet from './termsheet';
import AboutSection from './aboutSection';
import CamDirectorList from './camDirectorList';
import CamFinDetails from './camFinDetails';
import CamBorrowingProfile from './camBorrowing';
import CamCustomerSupplier from './camCustomerSupplier';
import CamKeyStrength from './camKeystrength';
import CamProfile from './camProfile';
import { getCamData } from 'http/fundLync/cam.helper';
// import { isMobile } from 'react-device-detect';

const steps = [
    { display: "About the Entity", icon: PersonalDetailsIcon, complete: PersonalDetailsCompleteIcon, query: "about-section" },
    { display: "Directors & Shareholding", icon: DirectorListIcon, complete: DirectorListIconComplete, query: "list-of-directors" },
    { display: "Key strengths", icon: KeyStrengthIcon, complete: KeyStrengthIconComplete, query: "key-strengths" },
    { display: "Financial Summary", icon: FinSummaryIcon, complete: FinSummaryIconComplete, query: "financial-summary" },
    { display: "Debt Profile", icon: DebtIcon, complete: DebtIconComplete, query: "debt-profile" },
    { display: "Customers / Suppliers", icon: CustomerSupplierIcon, complete: CustomerSupplierIconComplete, query: "customer-supplier" },
    { display: "Termsheet", icon: TermsheetIcon, complete: TermsheetIconComplete, query: "termsheet" },
    { display: "Cam Preview", icon: CamIcon, complete: CamIconComplete, query: "cam-preview" },
];


const Stepper = () => {
    const user = decryptedValue(localStorage.getItem("user"));
    const [currentStep, setCurrentStep] = useState(1);
    const [completedSteps, setCompletedSteps] = useState([]);
    const [probeData, setProbeData] = useState('')
    const urlParams = new URLSearchParams(window.location.search);
    const encodedDealId = urlParams.get("dealId");
    const dealId = atob(encodedDealId);
    const aboutSectionRef = useRef();
    const listDirectorsRef = useRef();
    const keyStrengthRef = useRef();
    const FinSummaryRef = useRef();
    const debtRef = useRef();
    const customerSupplierRef = useRef();
    const termsheetrRef = useRef();
    const camRef = useRef();
    const navigate = useNavigate();
    const isStepCompleted = (step) => completedSteps.includes(step);

    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const [loadingApprove, setLoadingApprove] = useState(false);

    useEffect(() => {
        if(currentStep === 8){
            const interval = setInterval(() => {
                if (camRef.current) {
                    setLoadingSubmit(camRef.current.isSubmitting());
                    setLoadingApprove(camRef.current.isApproving());
                    setProbeData(camRef.current.camData());
                }
            }, 100);
            return () => clearInterval(interval);
        }
        
    }, [camRef, currentStep]);
    const scrollToActiveStep = (stepIndex) => {
        const stepper = document.querySelector(".stepper");
        const step = stepper?.querySelectorAll(".step-item")[stepIndex - 1];
    
        if (step) {
            const stepLeftPosition = step.offsetLeft;
            const stepWidth = step.offsetWidth;
            const stepperWidth = stepper.offsetWidth;
    
            // Calculate the scroll position to center the step
            const scrollPosition = stepLeftPosition - stepperWidth / 2 + stepWidth / 2;
    
            stepper.scrollTo({
                left: scrollPosition,
                behavior: "smooth",
            });
        }
    };
    
    const handleNext = async () => {
        const refMap = {
            1: aboutSectionRef,
            2: listDirectorsRef,
            3: keyStrengthRef,
            4: FinSummaryRef,
            5: debtRef,
            6: customerSupplierRef,
            7: termsheetrRef,
            8: camRef,
        };

        const currentRef = refMap[currentStep];
        if (currentRef?.current) {
            currentRef.current.handleSubmit();
            const isValid = await currentRef.current.getValidationStatus();
            if (isValid) {
                setCompletedSteps((prev) => {
                    if (!prev.includes(currentStep)) return [...prev, currentStep];
                    return prev;
                });
                if (currentStep < steps.length) {
                    setTimeout(() => {
                        setCurrentStep(currentStep + 1);
                        scrollToActiveStep(currentStep + 1);
                        updateURLQuery(currentStep + 1);
                        if (currentStep == 5) {
                            document.querySelector(".stepper").scrollBy({ left: 750, behavior: "smooth" })
                        }
                    }, 1000);
                }
            } else {
                console.log("Validation failed for step", currentStep);
            }
        }
    };
    const updateURLQuery = (step) => {
        const stepData = steps[step - 1];
        const currentQuery = queryString.parse(location.search);
        const updatedQuery = { ...currentQuery, step: stepData.query };
        const newURL = `${location.pathname}?${queryString.stringify(updatedQuery)}`;
        navigate(newURL, { replace: true });
    };

    useEffect(() => {
        const currentQuery = queryString.parse(location.search);
        const stepIndex = steps.findIndex((step) => step.query === currentQuery.step);
        if (stepIndex !== -1) {
            setCurrentStep(stepIndex + 1);
            const completedStepNumbers = Array.from({ length: stepIndex }, (_, i) => i + 1);
            setCompletedSteps((prev) => {
                const updatedSteps = new Set([...prev, ...completedStepNumbers]);
                return Array.from(updatedSteps);
            });
        }
    }, [location.search])

    const getQueryStringForStep = (currentStep) => {
        const stepData = steps[currentStep - 1];
        return stepData ? stepData.query : null;
    };
    const queryStringForStep = getQueryStringForStep(currentStep);

    // useEffect(() => {
    //     if (currentStep === 8) {
    //         const fetchData = () => {
    //             getCamData({ dealId })
    //                 .then((response) => {
    //                     if (response) setProbeData(response.data[0] || {});
    //                 })
    //                 .catch((error) => console.error("Error fetching CAM data:", error));
    //         };

    //         fetchData();

    //         // const intervalId = setInterval(fetchData, 5000); // Poll every 5 seconds
    //         // return () => clearInterval(intervalId);
    //     }
    // }, [currentStep]);

    const handleBack = async () => {
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
            scrollToActiveStep(currentStep - 1); 
            updateURLQuery(currentStep - 1);
            if (currentStep > 4) {
                document.querySelector(".stepper").scrollBy({ left: -250, behavior: "smooth" })
            }
        }
    };

    const handleSubmit = async () => {
        if (camRef.current) {
            try {
                camRef.current.handleSubmit();
                const isValid = await camRef.current.getValidationStatus();

                if (isValid) {
                    if (currentStep < steps.length) {
                        setCurrentStep((prevStep) => prevStep + 1);

                        if (currentStep === 5) {
                            document.querySelector(".stepper").scrollBy({ left: 500, behavior: "smooth" });
                        }
                    }
                } else {
                    console.error("Validation failed for current step.");
                }
            } catch (error) {
                console.error("Error in handleSubmit:", error);
            }
        }
        return
    }
    const handleApprove = async () => {
        if (camRef.current) {
            try {
                camRef.current.handleApprove();
                const isValid = await camRef.current.getValidationStatus();

                if (isValid) {
                    if (currentStep < steps.length) {
                        setCurrentStep((prevStep) => prevStep + 1);

                        // Smooth scroll logic
                        if (currentStep === 5) {
                            document.querySelector(".stepper").scrollBy({ left: 500, behavior: "smooth" });
                        }
                    }
                } else {
                    console.error("Validation failed for current step.");
                }
            } catch (error) {
                console.error("Error in handleSubmit:", error);
            }
        }
        return
    }
    const handleStepClick = (step) => {
        if (isStepCompleted(step)) {
            setCurrentStep(step);
            updateURLQuery(step);
        }
    };

    return (
        <React.Fragment>
            <div className="page-content ">
            <Container fluid className='vertical-scroll'>
          <Breadcrumbs title="CAM GENERATION" />
    <Row className=" flex-column">
        <Col xs="10" md="12" className="stepper-container mb-4">
            <button
                className='stepper-arrow left-arrow'
                type='button'
                onClick={() =>
                    document.querySelector(".stepper").scrollBy({ left: -250, behavior: "smooth" })
                }
            >
                {"<"}
            </button>
            <div className="stepper">
                {steps.map((details, index) => {
                    const stepNumber = index + 1;
                    const isActive = stepNumber === currentStep;
                    const isCompleted = isStepCompleted(stepNumber);
                    return (
                        <div key={index} className="d-flex align-items-center" id="maindiv">
                            <div
                                className={`d-flex align-items-center justify-content-center thisdiv step-item ${isActive ? "active" : ""} ${isCompleted ? "complete" : ""}`}
                                onClick={() => handleStepClick(stepNumber)}
                                style={{
                                    cursor: isCompleted ? "pointer" : "not-allowed",
                                    height: "50px",
                                    fontWeight: 500,
                                    borderBottom: isActive
                                        ? "4px solid #25a848"
                                        : "4px solid transparent",
                                }}
                            >
                                <div
                                    style={{ marginRight: "12px" }}
                                    className={`circle ${isCompleted ? "completed" : ""} ${isActive ? "complete_active" : ""}`}
                                >
                                    {isCompleted ? "✔" : stepNumber}
                                </div>
                                <div
                                    className={`${isCompleted ? "label-completed" : "label"}`}
                                    style={{
                                        fontSize: "14px",
                                        fontWeight: 600,
                                        textAlign: "left",
                                    }}
                                >
                                    <span className='display'>{details.display}</span>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
            <button
                className='stepper-arrow right-arrow'
                type='button'
                onClick={() =>
                    document.querySelector(".stepper").scrollBy({ left: 250, behavior: "smooth" })
                }
            >
                {">"}
            </button>
        </Col>
        <Col xs="12" md="12">
            <div className="p-4 border rounded">
                <Row>
                    <Col xs="12" md="12">
                        {/* Render the current step */}
                        {currentStep === 1 && <AboutSection ref={aboutSectionRef} queryString={queryStringForStep} />}
                        {currentStep === 2 && <CamDirectorList ref={listDirectorsRef} queryString={queryStringForStep} />}
                        {currentStep === 3 && <CamKeyStrength ref={keyStrengthRef} queryString={queryStringForStep} />}
                        {currentStep === 4 && <CamFinDetails ref={FinSummaryRef} queryString={queryStringForStep} />}
                        {currentStep === 5 && <CamBorrowingProfile ref={debtRef} queryString={queryStringForStep} />}
                        {currentStep === 6 && <CamCustomerSupplier ref={customerSupplierRef} queryString={queryStringForStep} />}
                        {currentStep === 7 && <EntityTermsheet ref={termsheetrRef} queryString={queryStringForStep} />}
                        {currentStep === 8 && <CamProfile ref={camRef} />}
                    </Col>
                </Row>
                <div className="navigation-buttons d-flex justify-content-between mt-1">
                    {currentStep === 1 && (
                        <Button
                            type="button"
                            color="success"
                            onClick={() => aboutSectionRef.current.toggleModal()}
                        >
                            <i className="mdi mdi-plus me-1" />
                            New Field
                        </Button>
                    )}
                    {currentStep === 3 && (
                        <Button
                            type="button"
                            color="success"
                            onClick={() => keyStrengthRef.current.toggleModal()}
                        >
                            <i className="mdi mdi-plus me-1" />
                            New Field
                        </Button>
                    )}
                    {currentStep > 1 && currentStep !== 3 && (
                        <Button
                            type="button"
                            outline
                            className="right"
                            color="success"
                            onClick={handleBack}
                        >
                            Back
                        </Button>
                    )}
                    <div className="d-flex justify-content-end gap-2">
                        {currentStep === 3 && (
                            <Button
                                type="button"
                                outline
                                className="right"
                                color="success"
                                onClick={handleBack}
                            >
                                Back
                            </Button>
                        )}
                        {currentStep === 1 && <span className='right'>{" "}</span>}
                        {currentStep < steps.length ? (
                            <Button className='right' color="success" onClick={handleNext}>
                                Next
                            </Button>
                        ) : (
                            probeData.submittedBy !== null ? (
                                probeData.submittedBy !== user.id ? (
                                    <Button onClick={handleSubmit} color="success" disabled>
                                        Submit
                                    </Button>
                                ) : (
                                    <Button onClick={handleSubmit} color="success">
                                        {loadingSubmit ? (
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <Spinner className="spinner" size="sm" />
                                                <span style={{ paddingLeft: "5px" }}>Submitting...</span>
                                            </div>
                                        ) : "Submit"}
                                    </Button>
                                )
                            ) : (
                                <Button onClick={handleSubmit} color="success">
                                    {loadingSubmit ? (
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <Spinner className="spinner" size="sm" />
                                            <span style={{ paddingLeft: "5px" }}>Submitting...</span>
                                        </div>
                                    ) : "Submit"}
                                </Button>
                            )
                        )}
                        {currentStep < steps.length ? null : (
                            probeData.isApproved === 1 ? (
                                <Button onClick={handleApprove} color="success" disabled>
                                    Approved
                                </Button>
                            ) : (
                                probeData.approvedTo !== null && probeData.approvedTo === user.id && (
                                    <Button onClick={handleApprove} color="success">
                                        {loadingApprove ? (
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <Spinner className="spinner" size="sm" />
                                                <span style={{ paddingLeft: "5px" }}> Approving...</span>
                                            </div>
                                        ) : "Approve"}
                                    </Button>
                                )
                            )
                        )}
                    </div>
                </div>
                <div className='right d-flex flex-column align-items-end mt-2'>
                    {currentStep < steps.length ? null : (
                        probeData.submittedBy !== null && (
                            <span>
                                Submitted By {probeData?.submittedByUser?.firstName} {probeData?.submittedByUser?.lastName}
                            </span>
                        )
                    )}
                    {currentStep < steps.length ? null : (
                        probeData.isApproved === 1 && (
                            <span>
                                Approved By {probeData?.approvedToUser?.firstName} {probeData?.approvedToUser?.lastName}
                            </span>
                        )
                    )}
                </div>
            </div>
        </Col>
    </Row>
    <Row></Row>
</Container>

            </div>
        </React.Fragment >
    );
};
export default Stepper;